import config from '@/config'
import Groups from '@/models/Groups'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.GOKOLLAB_SERVER_URL)

export default class MarketplaceGroupsService extends BaseService<any> {
  protected basePath = ''

  constructor() {
    super(config?.GOKOLLAB_LOCATION_ID)
    this.basePath = `/${config?.GOKOLLAB_LOCATION_ID}/marketplace-groups`
  }

  model(): typeof Groups {
    return Groups
  }

  async getMarketplaceGroupById(groupId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${groupId}`)
    return response.data
  }

  async updateMarketplaceGroup(
    groupId: string,
    param: { marketplaceGroupSlug?: string }
  ): Promise<any> {
    const response = await http.patch(`${this.endpoint}/${groupId}`, param)
    return response.data
  }

  async activateCommunitiesInMarketplace(communities: {
    marketplaceLocationId: string
    groupLocationId: string
    groupIds: string[]
  }): Promise<any> {
    const response = await http.post(`${this.endpoint}/activate`, communities)
    return response.data
  }

  async deactivateCommunitiesFromMarketplace(communities: {
    marketplaceLocationId: string
    groupLocationId: string
    groupIds: string[]
  }): Promise<any> {
    const response = await http.post(`${this.endpoint}/deactivate`, communities)
    return response.data
  }

  async generateContactToken(
    groupId: string,
    locationId: string
  ): Promise<any> {
    const response = await http.post(`${this.endpoint}/contact-token`, {
      groupId,
      groupLocationId: locationId,
    })
    return response.data
  }
}
